<template>
    <div class="loading-dots">
        <span class="dot" :class="{ 'active': currentDot === 1 }"></span>
        <span class="dot" :class="{ 'active': currentDot === 2 }"></span>
        <span class="dot" :class="{ 'active': currentDot === 3 }"></span>
    </div>
</template>

<script setup lang="ts">
const currentDot = ref(1);

onMounted(() => {
    const interval = setInterval(() => {
        currentDot.value = currentDot.value === 3 ? 1 : currentDot.value + 1;
    }, 300);

    onUnmounted(() => {
        clearInterval(interval);
    });
});
</script>

<style lang="scss" scoped>
.loading-dots {
    @apply flex items-center gap-1;
}

.dot {
    @apply w-2 h-2 rounded-full bg-gray-200 transition-all duration-100 ease-in-out;
    
    &.active {
        @apply bg-gray-400 scale-125;
    }
}
</style> 